import Vue from 'vue'
import Notification from './notification.vue'
let MessageCtor = Vue.extend(Notification)
let instances = []
const fixedVerticalOffset = 16
let _eidCount = 0
const notification = (options) => {
  if (typeof window === 'undefined') return
  options = options || {}
  let verticalOffset = 0
  if (instances.length === 0) {
    verticalOffset = fixedVerticalOffset + (options.offset || 0)
  } else {
    verticalOffset = instances[instances.length - 1].$el.offsetTop + instances[instances.length - 1].$el.offsetHeight + fixedVerticalOffset
  }
  options.verticalOffset = verticalOffset
  let func = null
  if (options.onClose && typeof options.onClose === 'function') {
    func = options.onClose
  }
  options.onClose = (function (func) {
    return function () {
      let mark = -1
      instances.forEach((v, i) => {
        if (v._eid === instance._eid) {
          mark = i
        } else if (v._eid > instance._eid) {
          v.verticalOffset -= (v.$el.offsetHeight + fixedVerticalOffset)
          v._eid -= 1
        }
      })
      instances.splice(mark, 1)
      if (func) {
        func.apply(this)
      }
    }
  })(func)
  let instance = new MessageCtor({ data: options })
  instances.push(instance)
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance._eid = ++_eidCount
  instance.visible = true
  return instance
}
export default notification
